import { StudentExamTimetable } from '@features/student-page/sub-features/student-exam-timetable/components/StudentExamTimetable'
import { ScrollArea } from '@mantine/core'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_layout/students/$studentNo/exam-timetable',
)({
  component: RouteComponent,
  staticData: {
    crumb: {
        label: 'Exam Timetable',
    }
  }
})

function RouteComponent() {

    const { studentNo } = Route.useParams()

    return (
        <ScrollArea
            h="100%"
            className="min-h-0 min-w-0"
            p={5}
            type="auto"
            scrollbars="y"
            offsetScrollbars="y"
            styles={{ content: { display: 'block' } }}
        >
            <StudentExamTimetable studentNo={studentNo}/>
        </ScrollArea>
    )
}
